import type { MouseEvent } from "react";

/**
 * onClick for a control that carries a real `href` but navigates in-app.
 *
 * Only a plain left click is intercepted: Ctrl/Cmd/Shift/Alt clicks fall
 * through to the browser so "open in new tab/window" keeps working, which is
 * the whole reason these controls carry an href instead of relying on MUI's
 * `component={RouterLink}` polymorphism.
 */
export const spaNavigate =
  (navigate: () => void) => (event: MouseEvent<HTMLElement>) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }
    event.preventDefault();
    navigate();
  };
